import React from 'react';
import { Link } from 'react-router-dom';

function MediaGalleryCard({ gallery }) {
  const href = `/media-centre/${gallery.slug}`;

  return (
    <article className="media-gallery-card">
      <Link to={href} className="media-gallery-card__link">
        <div className="media-gallery-card__media">
          <img
            src={gallery.coverImage}
            alt=""
            loading="lazy"
            className="media-gallery-card__image"
          />
        </div>
        <div className="media-gallery-card__body">
          <time className="media-gallery-card__date" dateTime={gallery.date}>
            {gallery.dateLabel}
          </time>
          <h3 className="media-gallery-card__title">{gallery.title}</h3>
          <p className="media-gallery-card__description">{gallery.description}</p>
          <span className="media-gallery-card__cta">
            View Gallery{' '}
            <span className="media-gallery-card__cta-arrow" aria-hidden="true">
              ➔
            </span>
          </span>
        </div>
      </Link>
    </article>
  );
}

export default MediaGalleryCard;
